export function getImageSize(url: string) {
  const img = document.createElement('img');

  const promise: Promise<{ height: number; width: number }> = new Promise((resolve) => {
    img.onload = () => {
      // Natural size is the actual image size regardless of rendering.
      // The 'normal' `width`/`height` are for the **rendered** size.
      const width = img.naturalWidth;
      const height = img.naturalHeight;

      // Resolve promise with the width and height
      resolve({ width, height });
    };

    // Reject promise on error
    img.onerror = () => resolve({ width: 0, height: 0 });
  });

  // Setting the source makes it start downloading and eventually call `onload`
  img.src = url;

  return promise;
}

export function fileToUrl(f: File) {
  return window.URL.createObjectURL(f);
}
